import React from 'react';
import './AuthErrorBar.css';

export default function AuthErrorBar() {
    return (
        <div className="auth-error-bar">
            <div className="auth-error-content">
                <span className="auth-error-icon">⚠️</span>
                <span className="auth-error-message">
                    You need to be authorized by an admin to access this page.
                </span>
            </div>
        </div>
    );
} 